import { useContext } from "react";
import { userProfile } from "../components/Context/UserContext.d";
import { UserContext } from "../components/Context/UserContext";
export default function useUserProfile(): userProfile {
	return useContext(UserContext);
}
